export const dueDateForProjects = new Date(Date.UTC(2020, 4, 22, 12));
export const dueDateForHiroNFT = process.env.REACT_APP_HIRO_NFT_START_DATE ? new Date(process.env.REACT_APP_HIRO_NFT_START_DATE) : null
